import React, { useEffect, useState, useRef } from 'react';
import { Typography } from '@mui/material';
import { flowValidationAtom } from '../../../../Services/_states';
import { useRecoilValue } from 'recoil';
import RenderTextArea from './RenderTextArea.tsx';

interface SuggetionObj {
  label: string;
  value: string;
  paramType?: string;
}

const WhatsAppFlowNode = ({ data }: any) => {
  const flowValidationObj = useRecoilValue(flowValidationAtom);
  const [flowId, setFlowId] = useState(data?.flowId || '');
  const [flowToken, setFlowToken] = useState(data?.flowToken || '');
  const [firstScreenName, setFirstScreenName] = useState(data?.firstScreenName || '');
  const [flowStatus, setFlowStatus] = useState(data?.flowStatus || '');
  const [bodyText, setBodyText] = useState(data?.body || '');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [cursorPosition, setCursorPosition] = useState < number | null > (null);
  const [customData, setCustomData] = useState('');
  const textareaRef = useRef < HTMLTextAreaElement > (null);

  useEffect(() => {
    if (data?.body !== bodyText) {
      setBodyText(data?.body || '');
    }
  }, [data?.body]);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 12}px`;
    }
  }, [bodyText]);

  const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setBodyText(value);

    const cursorPos = e.target.selectionStart;
    const textBeforeCursor = value.slice(0, cursorPos);

    // Detect `{{@` pattern
    const match = textBeforeCursor.match(/{{@(\w*)$/);
    if (match) {
      // const query = match[1]; // Get the text after `{{@`
      // setFilteredSuggestions(suggestions.filter((s) =>s.label.toLowerCase().includes(query.toLowerCase())));
      setShowSuggestions(true);
      setCursorPosition(cursorPos);
    } else {
      setShowSuggestions(false);
    }

    // Update `params` by finding all valid `{{label}}` entries in the text
    const matches = value.match(/{{(.*?)}}/g); // Match all `{{label}}`
    const labelsInBody = matches ? matches.map((match) => match.replace(/{{|}}/g, '')) : [];

    // Categorize params by `paramType`
    const categorizedParams: any = {
      global: [],
      result: [],
      webform: [],
    };

    data.parentResults.forEach((result: SuggetionObj) => {
      if (labelsInBody.includes(result.label)) {
        if (result.paramType === 'global') {
          categorizedParams.global.push(result.value);
        } else if (result.paramType === 'result') {
          categorizedParams.result.push(result.value);
        } else if (result.paramType === 'webform') {
          categorizedParams.webform.push(result.value);
        }
      }
    });

    // Update parent data
    data.onChange(data.id, { body: value, params: categorizedParams });

    // Adjust the textarea height to fit content
    // if (textareaRef.current) {
    //   textareaRef.current.style.height = "auto"; // Reset height
    //   textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 12
    //     }px`; // Set height to content
    // }
  };

  const handleSuggestionClick = (suggestion: SuggetionObj) => {
    if (cursorPosition !== null) {
      const textBeforeCursor = bodyText.slice(0, cursorPosition);
      const textAfterCursor = bodyText.slice(cursorPosition);
      const updatedText =
        textBeforeCursor.replace(/{{@\w*$/, `{{${suggestion.label}}}`) + textAfterCursor;

      setBodyText(updatedText);
      setShowSuggestions(false);

      // Initialize parameters if not present
      const updatedParams = {
        global: data.params?.global || [],
        result: data.params?.result || [],
        webform: data.params?.webform || [],
      };

      // Add the value to the correct array based on paramType
      if (suggestion.paramType === 'global') {
        updatedParams.global = [...updatedParams.global, suggestion.value];
      } else if (suggestion.paramType === 'result') {
        updatedParams.result = [...updatedParams.result, suggestion.value];
      } else if (suggestion.paramType === 'webform') {
        updatedParams.webform = [...updatedParams.webform, suggestion.value];
      }

      // Update parent data
      data.onChange(data.id, { body: updatedText, params: updatedParams });

      // Move cursor to the end of the inserted suggestion
      // setTimeout(() => {
      //   textareaRef.current?.setSelectionRange(
      //     updatedText.length,
      //     updatedText.length
      //   );
      // }, 0);
    }
  };

  const handleInputChange = (field: string, value: string) => {
    switch (field) {
      case 'flowId':
        setFlowId(value);
        break;
      case 'flowToken':
        setFlowToken(value);
        break;
      case 'firstScreenName':
        setFirstScreenName(value);
        break;
      case 'flowStatus':
        setFlowStatus(value);
        break;
      // case 'header':
      //   setHeader(value.slice(0, 20));
      //   break;
      // case 'body':
      //   setBody(value.slice(0, 1024));
      //   break;
      // case 'footer':
      //   setFooter(value.slice(0, 60));
      //   break;
      case 'customData':
        setCustomData(value);
        break;
      default:
        break;
    }
    data.onChange(data.id, { [field]: value });
  };

  return (
    <div
      style={{
        padding: '10px',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '8px',
      }}
    >
      {/* Flow ID */}
      <div style={{ marginBottom: '10px' }}>
        <label>Flow ID:</label>
        <input
          type="text"
          value={flowId}
          onChange={(e) => handleInputChange('flowId', e.target.value)}
          placeholder="Enter Flow ID"
          style={inputStyle}
        />
        {flowValidationObj[data?.id]?.flowId && (
          <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
            {flowValidationObj[data?.id]?.flowId}
          </Typography>
        )}
      </div>

      {/* Flow Token */}
      <div style={{ marginBottom: '10px' }}>
        <label>Flow Token:</label>
        <input
          type="text"
          value={flowToken}
          onChange={(e) => handleInputChange('flowToken', e.target.value)}
          placeholder="Enter Flow Token"
          style={inputStyle}
        />
        {flowValidationObj[data?.id]?.flowToken && (
          <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
            {flowValidationObj[data?.id]?.flowToken}
          </Typography>
        )}
      </div>

      {/* First Screen Name */}
      <div style={{ marginBottom: '10px' }}>
        <label>First Screen Name:</label>
        <input
          type="text"
          value={firstScreenName}
          onChange={(e) => handleInputChange('firstScreenName', e.target.value)}
          placeholder="Enter First Screen Name"
          style={inputStyle}
        />
        {flowValidationObj[data?.id]?.firstScreenName && (
          <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
            {flowValidationObj[data?.id]?.firstScreenName}
          </Typography>
        )}
      </div>

      {/* Flow Status */}
      <div style={{ marginBottom: '10px' }}>
        <label>Flow Status:</label>
        <select
          value={flowStatus}
          onChange={(e) => handleInputChange('flowStatus', e.target.value)}
          style={inputStyle}
        >
          <option value="">Select Status</option>
          <option value="Draft">Draft</option>
          <option value="Published">Published</option>
        </select>
      </div>

      {/* Header */}
      <div style={{ marginBottom: '10px', position: 'relative' }}>
        <label>Header:</label>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            value={data?.header || ''}
            onChange={(e) => {
              const newHeader = e.target.value.slice(0, 60);
              data.onChange(data.id, { header: newHeader });
            }}
            placeholder="Enter Header Text"
            style={{
              width: '100%',
              padding: '5px',
              paddingRight: '50px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: '#f5f5f5',
            }}
          />
          <span
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '12px',
              color: data.header?.length === 60 ? 'red' : '#888',
            }}
          >
            {`${(data.header || '').length}/60`}
          </span>
        </div>
        {flowValidationObj[data?.id]?.header && (
          <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
            {flowValidationObj[data?.id]?.header}
          </Typography>
        )}
      </div>

      {/* Body */}
      <RenderTextArea
        data={data}
      />
      {flowValidationObj[data?.id]?.body && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.body}
        </Typography>
      )}

      {/* Suggestions Dropdown */}
      {/* {showSuggestions && data?.parentResults.length > 0 && (
        <div
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: 4,
            zIndex: 1000,
            width: '100%',
          }}
        >
          {data?.parentResults?.map((suggestion: SuggetionObj, index: any) => (
            <div
              key={`${data?.id}-${index}`}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                padding: '5px 10px',
                cursor: 'pointer',
                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
              }}
            >
              {suggestion?.label}
            </div>
          ))}
        </div>
      )} */}

      <div style={{ marginBottom: '10px', position: 'relative' }}>
        <label>Footer:</label>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            value={data.footer || ''}
            onChange={(e) => {
              const newFooter = e.target.value.slice(0, 60);
              data.onChange(data.id, { footer: newFooter });
            }}
            placeholder="Enter Footer Text"
            style={{
              width: '100%',
              padding: '5px',
              paddingRight: '50px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: '#f5f5f5',
            }}
          />
          <span
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '12px',
              color: data.footer?.length === 60 ? 'red' : '#888',
            }}
          >
            {`${(data?.footer || '').length}/60`}
          </span>
        </div>
        {flowValidationObj[data?.id]?.footer && (
          <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
            {flowValidationObj[data?.id]?.footer}
          </Typography>
        )}
      </div>

      {/* Add Custom Data Option */}
      <div style={{ marginBottom: '10px' }}>
        <label>
          <input
            type="checkbox"
            checked={data?.isCustomData}
            onChange={(e) => data.onChange(data.id, { isCustomData: e.target.checked })}
          />{' '}
          Add Custom Data
        </label>
      </div>

      {data?.isCustomData && (
        <div style={{ marginBottom: '10px', position: 'relative' }}>
          <label>Custom Data (JSON):</label>
          <textarea
            value={customData}
            onChange={(e) => handleInputChange('customData', e.target.value)}
            placeholder="Enter custom JSON data"
            style={textareaStyle}
          />
        </div>
      )}
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '5px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  background: '#f5f5f5',
};

const textareaStyle = {
  width: '100%',
  height: 'auto',
  padding: '5px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  background: '#f5f5f5',
  overflow: 'hidden',
  resize: 'none',
};

export default WhatsAppFlowNode;